import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { MDBContainer } from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { handleNavLinks } from "Projects/CC_cubi_clan_project/Utils/Utils";
import { getApp, getAppPermisions } from "Projects/CC_cubi_clan_project/Utils/PermissionManager";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import { TabsTablas } from "../../Components/TabsTablas/TabsTablas";

export default function TABLNHomeView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [navActive, setNavActive] = useState("Home");
  const [isLoading, setLoading] = useState(false);
  const [appPermissions, setAppPermissions] = useState([]);
  const [navMenu, setNavMenu] = useState();
  const [tablas, setTablas] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(["miCookie"]);

  const navMenuDefault = [
    {
      devName: "Home",
      label: "Home",
      url: "/tabl",
      active: true,
      disabled: false,
      permissionRequired: ["USER_ACCESS"]
    },
    {
      devName: "AppList",
      label: "Aplicaciones",
      active: false,
      disabled: false,
      permissionRequired: [],
    },
  ];

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData(event) {
    let app = await getApp("TABL", setLoading);
    let appPermissions = await getAppPermisions(app, setLoading);
    setAppPermissions(appPermissions);
    setNavMenuVisibles(appPermissions);
    await getAllTablasVersionesByUsuariosTablas();
  }

  function setNavMenuVisibles(appPermissions) {
    for (let nav of navMenuDefault) {
      nav.visible = true;
      for (let per of nav.permissionRequired) {
        if (!appPermissions?.find((element) => element.nombre === per)) {
          nav.visible = false;
          break;
        }
      }
    }
    setNavMenu(navMenuDefault);
  }

  async function getAllTablasVersionesByUsuariosTablas() {
    try {
      let userDataJson = sessionStorage.getItem("userData");
      let userData = userDataJson ? JSON.parse(userDataJson) : {};
      let method = `tablas/getAllByUsers?idUsuarios=${userData.IDUsuario}`;
  
      const response = await doFetch("TABL", method, null);
      const data = await response.json();
      if (data.STATE === "SUCCESS") {
        const tablasConVersiones = data.DATA[0].value.map(tabla => ({
          IDTabla: tabla.IDTabla,
          codigoTabla: tabla.codigoTabla,
          versiones: tabla.TABLTablasVersionesCollection
        }));
        setTablas(tablasConVersiones);
      } else {
        console.error("Error al obtener datos:", data.MESSAGE);
      }
    } catch (error) {
      console.error("Error al obtener datos:", error);
    } finally {
      setLoading(false);
    }
  }

  const onHandleNavLinks = (event, url) => {
    handleNavLinks(event, url, navigate, setNavActive);
  };

  return (
    <div>
      <LoadingSpinner isLoading={isLoading}/>
      {navMenu ? (
        <NavMenu
          title="Single Sign On"
          appCode="TABL"
          navMenu={navMenu}
          isLoggedIn={true}
          onHandleNavLinks={onHandleNavLinks}
          onLoading={setLoading}
          onNavigate={navigate}
        />
      ) : (
        <></>
      )}
      {tablas ? (
        <MDBContainer>
          <TabsTablas tablas={tablas} />
        </MDBContainer>
      ) : (
        <></>
      )}
    </div>
  );
}
